























































import Vue, { PropType } from 'vue'
import IListIcon from '@/types/components/IListIcon.interface'

export default Vue.extend({
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {
            type: Object as PropType<IListIcon>,
            default: null
        }
    }
})
